import { Injectable } from '@angular/core';
import { ReplaySubject, Observable } from 'rxjs';
import { filter } from 'rxjs/operators';
import { setTimeout$ } from '../core/common';
import { PRIMARY_SPINNER, Spinner, NgxSpinner } from '../modules/shared/components/spinner/spinner.enum';

@Injectable({
  providedIn: 'root'
})
export class SpinnerService {
  private static spinners: any[] = [];
  private spinnerObservable = new ReplaySubject<NgxSpinner>(1);

  constructor() { }
  hideAll() {
    while (SpinnerService.spinners.length) {
      this.hide(SpinnerService.spinners.pop());
    }
  }

  getSpinner(name: string): Observable<NgxSpinner> {
    return this.spinnerObservable.asObservable().pipe(filter((x: NgxSpinner) => x && x.name === name));
  }

  static promises: any = {};
  show(name: string = PRIMARY_SPINNER, spinner?: Spinner, delay = 500) {
    if (name) {
      const index = SpinnerService.spinners.findIndex(_ => _ === name);
      if (index < 0) { SpinnerService.spinners.push(name); }
    }
    const showPromise = new Promise((resolve, _reject) => {
      setTimeout$(() => {
        if (!SpinnerService.promises[name || 'general']) return;

        if (spinner && Object.keys(spinner).length) {
          spinner['name'] = name;
          this.spinnerObservable.next(new NgxSpinner({ ...spinner, show: true }));
          resolve(true);
        } else {
          this.spinnerObservable.next(new NgxSpinner({ name, show: true }));
          resolve(true);
        }

      }, delay);
    });

    SpinnerService.promises[name || 'general'] = true;
    return showPromise;
  }

  hide(name: string = PRIMARY_SPINNER, debounce: number = 0) {
    if (name) {
      const index = SpinnerService.spinners.findIndex(_ => _ === name);
      if (index >= 0) { SpinnerService.spinners.splice(index, 1); }
    }
    const hidePromise = new Promise((resolve, _reject) => {
      setTimeout$(() => {
        this.spinnerObservable.next(new NgxSpinner({ name, show: false }));
        resolve(true);
      }, debounce);
    });
    SpinnerService.promises[name || 'general'] = false;
    return hidePromise;
  }
}
